import {
  Box,
  TextField,
  Modal,
  Button,
  Dialog,
  Typography,
} from "@mui/material";
import ModalContent from "../../../common/components/Modal";
import {
  AssetTransactionDto,
} from "../../../services/netServices";
import { useTranslation } from "react-i18next";
import { CustomListItem } from "../../checkList/components/ListItem";
import moment from "moment";
import { useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  data: AssetTransactionDto | null;
}

export default function AssetTransactionDetailModal({
  open,
  onClose,
  data,
}: Props): JSX.Element {
  const { t } = useTranslation() as any;
  const [openImage, setOpenImage] = useState(false);
  const [selectedImg, setSelectedImg] = useState<string | null>(null);

  const handleOpen = (url: string) => {
    setSelectedImg(url);
    setOpenImage(true);
  };

  const handleClose = () => {
    setOpenImage(false);
    setSelectedImg(null);
  };
  const shouldShowBoxes = (type?: string) => {
    switch (type) {
      case "add":
      case "restock":
        return { showFrom: false, showTo: false };
      case "assign":
        return { showFrom: false, showTo: true };
      case "transfer":
        return { showFrom: true, showTo: true };
      case "retire":
      case "sell":
        return { showFrom: true, showTo: false };
      default:
        return { showFrom: false, showTo: false };
    }
  };
  const { showFrom, showTo } = shouldShowBoxes(data?.TransactionType);
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <ModalContent onClose={onClose} title={t("00_06_detail")} width={600}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "80vh",
            }}
          >
           
            <Box mt={4}>
              <CustomListItem
                leftContainerWidth={150}
                text={t("34_00_transaction_type")}
                RightComponent={
                  <TextField
                    value={
                      (() => {
                        switch (data?.TransactionType) {
                          case "add":
                            return t("34_00_add");
                          case "assign":
                            return t("34_00_assign");
                          case "retire":
                            return t("34_00_retire");
                          case "transfer":
                            return t("34_00_transfer");
                          case "restock":
                            return t("34_00_restock");
                          case "sell":
                            return t("34_00_sell");
                          default:
                            return (data?.TransactionType ?? "");
                        }
                      })()
                    }
                    variant="standard"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                }
              />

            </Box>
            <Box my={4}>
              <CustomListItem
                leftContainerWidth={150}
                text={t("00_06_quantity")}
                RightComponent={
                  <TextField
                    value={data?.Quantity ?? ""}
                    variant="standard"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                }
              />
            </Box>
            {showFrom && (
              <>
                {data?.TransactionType === "transfer" && (
                  <Typography
                    color="#636363"
                    sx={{ textTransform: "uppercase" }}
                    mb={1}
                  >
                    {t("34_00_from")}
                  </Typography>
                )}
                <Box
                  p={2}
                  mb={4}
                  sx={{ border: "1px solid #e0e0e0", borderRadius: 1 }}
                >
                  <CustomListItem
                    leftContainerWidth={150}
                    text={t("34_00_department")}
                    RightComponent={<TextField
                      value={data?.FromDepartmentName ?? ""}
                      variant="standard"
                      fullWidth
                      InputProps={{ readOnly: true, disableUnderline: true }} />} />
                  <Box mt={2}>
                    <CustomListItem
                      leftContainerWidth={150}
                      text={t("34_00_group")}
                      RightComponent={<TextField
                        value={data?.FromGroupName ?? ""}
                        variant="standard"
                        fullWidth
                        InputProps={{ readOnly: true, disableUnderline: true }} />} />
                  </Box>
                  <Box mt={2}>
                    <CustomListItem
                      leftContainerWidth={150}
                      text={t("34_00_employee")}
                      RightComponent={<TextField
                        value={data?.FromEmployeeName ?? ""}
                        variant="standard"
                        fullWidth
                        InputProps={{ readOnly: true, disableUnderline: true }} />} />
                  </Box>
                </Box></>
            )}

            {showTo && (
              <>
                {data?.TransactionType === "transfer" && (
                  <Typography
                    color="#636363"
                    sx={{ textTransform: "uppercase" }}
                    mb={1}
                  >
                    {t("34_00_to")}
                  </Typography>
                )}
                <Box
                  p={2}
                  mb={4}
                  sx={{ border: "1px solid #e0e0e0" }}
                >
                  <CustomListItem
                    leftContainerWidth={150}
                    text={t("34_00_department")}
                    RightComponent={<TextField
                      value={data?.ToDepartmentName ?? ""}
                      variant="standard"
                      fullWidth
                      InputProps={{ readOnly: true, disableUnderline: true }} />} />
                  <Box mt={2}>
                    <CustomListItem
                      leftContainerWidth={150}
                      text={t("34_00_group")}
                      RightComponent={<TextField
                        value={data?.ToGroupName ?? ""}
                        variant="standard"
                        fullWidth
                        InputProps={{ readOnly: true, disableUnderline: true }} />} />
                  </Box>
                  <Box mt={2}>
                    <CustomListItem
                      leftContainerWidth={150}
                      text={t("34_00_employee")}
                      RightComponent={<TextField
                        value={data?.ToEmployeeName ?? ""}
                        variant="standard"
                        fullWidth
                        InputProps={{ readOnly: true, disableUnderline: true }} />} />
                  </Box>
                </Box></>
            )}
            <Box>
              <CustomListItem
                leftContainerWidth={150}
                text={t("34_00_transaction_date")}
                RightComponent={
                  <TextField
                    value={
                      moment
                        .unix(Number(data?.TransactionDate))
                        .format("DD/MM/YYYY") ?? ""
                    }
                    variant="standard"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                }
              />
            </Box>

          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 4
            }}
          >
            <Button
              variant="contained"
              style={{ color: "#fff", backgroundColor: "#08B0A0" }}
              onClick={onClose}
            >
              {t("00_06_close")}
            </Button>
          </Box>
        </ModalContent>
      </Box>
    </Modal>
  );
}
